<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-info">
            <div class="common-text mb-2" v-if="title">
                {{title}}
            </div>
            <div class="main-text mb-5" v-if="text">
                {{text}}
            </div>
            <v-flex class="d-flex w-100 justify-end mt-6">
                <v-btn class="btn-gradient main-text" @click="close">
                    ОК
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalInfo",
    props: {
        value: {
            type: Boolean,
        },
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
            this.$emit('input', false);
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-info.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.btn-gradient.v-btn {
    max-width: 94px;
    text-transform: none;
}
</style>